import { Button, Position, Toast, Toaster } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { notificationsActionCreators } from 'src/actions/notifications/actionCreators';
import { getNotificationTestId } from 'src/constants/testIds';
import { Notification } from 'src/store/state/notifications';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const Notifications: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const notifications = useReduxSelector(
    (state) => state.notifications.notifications
  );

  const handleDismiss = (id: string) =>
    dispatch(notificationsActionCreators.dismissedNotification(id));

  return (
    <Toaster position={Position.BOTTOM_RIGHT}>
      {notifications.map(
        ({
          id,
          className,
          type,
          data,
          message,
          ...notification
        }: Notification) => (
          <Toast
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...notification}
            key={id}
            className={classNames(className, {
              'sd-toast-actionable': data?.actions,
            })}
            message={
              data?.actions ? (
                <>
                  <div className="sd-toast-actionable-message">
                    <span data-testid={getNotificationTestId(type)}>
                      {message}
                    </span>
                  </div>
                  <div className="sd-toast-actionable-actions">
                    {data.actions.map((action) => (
                      <Button
                        key={`${id}-${action.text}`}
                        data-testid={action.actionButtonTestId}
                        minimal
                        onClick={() => {
                          if (action.onClickAction) {
                            dispatch(action.onClickAction);
                          }
                          if (data.dismissOnAction) {
                            handleDismiss(id);
                          }
                        }}
                        text={action.text}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <span data-testid={getNotificationTestId(type)}>{message}</span>
              )
            }
            onDismiss={() => handleDismiss(id)}
          />
        )
      )}
    </Toaster>
  );
};
